import instance from "../utils/request.js"
/*请求登录*/
export function Login(data = {}){
    let params = new URLSearchParams();
    params.append('username',data.username);
    params.append('password',data.password);
    params.append('checkcode',data.checkcode);
    return instance.request({
        method: "post",
        url: "/lzjaiopsbase/login/",
        //headers:{'X-CSRFToken':Cookies.get("DjangoCookie")},
        data:params,
        timeout:360000
    })
}

/*退出系统*/
export function Logout(data = {}){
return instance.request({
        method: "post",
        url: "lzjaiopsbase/logout/",
        data:data
    })
}
